import { useContext } from 'react';
import { Navigate } from 'react-router';
import { LayoutContext } from '../context';

const STAFF_ROLES = ['admin', 'doctor', 'duty_doctor', 'moderator', 'supervisor'];

// role: 'staff' (врач/админ/…) | 'patient' | 'any'
export default function RequireAuth({ role = 'any', children }) {
  const { isVerified, account } = useContext(LayoutContext);

  if (!isVerified || !account) {
    const to = role === 'patient' ? '/login/patient' : '/login/doctor';
    return <Navigate to={to} replace />;
  }

  const roles = account.type_profile || [];
  const isStaff = STAFF_ROLES.some((r) => roles.includes(r));

  if (role === 'staff' && !isStaff) {
    // пациент попал в раздел персонала
    return <Navigate to="/cabinet" replace />;
  }
  if (role === 'patient' && isStaff) {
    // персонал попал в кабинет пациента
    return <Navigate to="/" replace />;
  }

  return children;
}